"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function backwardNavigation(navLevel, navTree, setIsTransitioning, setNavLevel, setPreviousNav, setNavTree, animationDuration) {
  var newNavLevel = navLevel - 1;
  var previousList = navTree.find(function (branch) {
    return branch.level === newNavLevel;
  });
  var newNavTree = navTree.slice(0, -1);
  if (!previousList) return;
  setIsTransitioning(true);
  setTimeout(function () {
    setNavLevel(newNavLevel);
    setPreviousNav({
      level: newNavLevel,
      links: previousList.links,
      parentId: previousList.parentId
    });
    setNavTree(newNavTree);
    setIsTransitioning(false);
  }, animationDuration / 2);
}
var _default = backwardNavigation;
exports["default"] = _default;